import styled from "styled-components";

export const Wrapper = styled.div`
  background: #30444e;
  width: 100vw;
  height: 96px;
  border-radius: 25px 25px 0 0;
  position: fixed;
  bottom: 0;
  /* display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  column-gap: 10%;
  justify-content: center;
  align-content: center; */
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
